import React from 'react';
import T from 'prop-types';

import Modal from '../../../../../components/Modal';
import Button from '../../../../../components/Buttons/Button';
import { toast } from '../../../../../components/Toasts';
import ProcessingToastContent from '../ProcessingToastContent';
import api from '../../../api';

const ExportFailedModal = ({
  open,
  report,
  onUpdateSuccess,
  onClose,
}) => {
  const handleSubmit = () => {
    const requestData = {
      custom_export: {
        export_type: 'csv',
      },
    };

    api.customExports.updateCustomExport(report, requestData)
      .then(() => {
        toast.success(<ProcessingToastContent />);
        onClose();
        onUpdateSuccess();
      }).catch(() => {
        toast.error('Oops! Something went wrong. Please, try again later');
        onClose();
      });
  };

  return (
    <Modal
      open={open}
      size="xs"
      closeButtonIconClass="hicon-close-2"
      modalClassName="upsert-export-modal export-failed-modal"
      onClose={onClose}
    >
      <div className="export-failed-modal__body">
        <i className="hicon-warning" />
        <h4 className="export-failed-modal__title">Export Failed</h4>
        <p>Excel does not support data files this large. You may still request a CSV file.</p>
        <p>Alternatively, you may adjust your selected time frame, data points, or number of entities and try again.</p>
      </div>

      <div className="export-failed-modal__footer">
        <Button
          size="lg"
          onClick={() => handleSubmit()}
        >
          Request CSV
        </Button>
        <Button
          size="lg"
          variant="secondary"
          onClick={() => onClose()}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

ExportFailedModal.propTypes = {
  open: T.bool.isRequired,
  report: T.object.isRequired,
  onUpdateSuccess: T.func,
  onClose: T.func.isRequired,
};

export default ExportFailedModal;
